import type { PatSnapSuccessResponseData } from '@patsnap/tahiti-core';
import { PsHttpService } from '@patsnap/tahiti-core';
import { injectable } from '@patsnap/tahiti-core/shared/inversify';

import type {
    GetCompanyTreeApi,
    GetCompanyTreeRequest,
    GetCompanyTreeResponse,
} from '../company-tree-api';
import type {
    GetCompanyNameApi,
    GetCompanyNameRequest,
    GetCompanyNameResponse,
} from '../company-name-api';
import { COMPANY_API_PATHS } from '../../constants';
import { coreTelecomApiUrlPrefix } from '@telecom/shared/domain-config';

@injectable()
export class CompanyTreeApiImpl
    extends PsHttpService
    implements GetCompanyTreeApi, GetCompanyNameApi
{
    get options() {
        return {
            baseURL: '/api',
            headers: {
                'X-API-Version': '2.0',
            },
        };
    }

    async getCompanyTree(data: GetCompanyTreeRequest): Promise<GetCompanyTreeResponse> {
        const result = await this.get<PatSnapSuccessResponseData<GetCompanyTreeResponse>>({
            url: COMPANY_API_PATHS.TREE,
            params: data,
            baseURL: coreTelecomApiUrlPrefix,
        });
        return result.data;
    }

    async getCompanyByName(data: GetCompanyNameRequest): Promise<GetCompanyNameResponse> {
        const result = await this.post<PatSnapSuccessResponseData<GetCompanyNameResponse>>({
            url: COMPANY_API_PATHS.NAME,
            data,
            baseURL: coreTelecomApiUrlPrefix,
        });
        return result.data;
    }
}
